
(function(){
  // Config
  const GIFT_VARIANT_ID = 52308475838804;   // your €0 gift variant id
  const THRESHOLD_CENTS = 4900;             // €49.00
  const MAX_SETTLE_MS = 1500;
  const SECOND_REPAINT_MS = 350;

  // If you later want to lock the cadeaubon precisely, put its product_id here, e.g. [1234567890123]
  const EXEMPT_PRODUCT_IDS = [8591941927252];

  const SECTION_IDS = [
    'cart-drawer','cart-notification','cart-icon-bubble',
    'main-cart-items','main-cart-footer','cart-live-region-text',
    'mini-cart','ajax-cart','header','header-drawer','thb-cart-drawer','thb-mini-cart'
  ];

  async function getCart(){
    const r = await fetch('/cart.js',{credentials:'same-origin'});
    return r.json();
  }

  function isGiftLine(item){
    if(!item) return false;
    if (item.properties && (item.properties._gift === '1' || item.properties._gift === 1 || item.properties._gift === true || item.properties._gift === 'true')) {
      return true;
    }
    return item.variant_id === GIFT_VARIANT_ID;
  }

  // Cadeaubon detection
  function isGiftCard(item){
    if (item.gift_card === true) return true; // native Shopify flag
    if ((item.product_type || '').toLowerCase() === 'gift card') return true;
    const title = (item.title || '').toLowerCase();
    if (/(gift\s*card|cadeaubon|cadeaukaart|geschenkkarte|geschenkkaart|bon\s*cadeau)/.test(title)) return true;
    if (Array.isArray(EXEMPT_PRODUCT_IDS) && EXEMPT_PRODUCT_IDS.includes(item.product_id)) return true;
    return false;
  }

  function findGiftLine(cart){
    return cart.items.find(isGiftLine);
  }

  // Only count non-gift and non-gift-card lines toward the threshold
  function eligibleSubtotalCents(cart){
    return cart.items.reduce((sum, item) => {
      if (isGiftLine(item)) return sum;
      if (isGiftCard(item)) return sum;
      const pre = item.original_line_price ?? item.line_price ?? 0;
      return sum + pre;
    }, 0);
  }

  async function waitForCartSettle(timeout=MAX_SETTLE_MS){
    const start = Date.now();
    let lastCount = -1, lastSubtotal = -1, stableFor = 0;
    while(Date.now() - start < timeout){
      try{
        const c = await getCart();
        const count = c.item_count || 0;
        const subtotal = c.items_subtotal_price || 0;
        if(count === lastCount && subtotal === lastSubtotal){
          stableFor += 100;
          if(stableFor >= 200) return c;
        } else {
          lastCount = count; lastSubtotal = subtotal; stableFor = 0;
        }
      } catch(e){}
      await new Promise(r => setTimeout(r, 100));
    }
    try { return await getCart(); } catch(e){ return null; }
  }

  async function addGiftTagged(){
    const body = new URLSearchParams();
    body.set('id', String(GIFT_VARIANT_ID));
    body.set('quantity', '1');
    body.set('properties[_gift]', '1');
    try{
      await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},
        credentials:'same-origin',
        body: body.toString()
      });
      return true;
    } catch(e){ return false; }
  }

  async function setLineQtyByKey(lineKey, qty){
    const body = new URLSearchParams();
    body.set('id', lineKey);
    body.set('quantity', String(qty));
    try{
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},
        credentials:'same-origin',
        body: body.toString()
      });
      return true;
    } catch(e){ return false; }
  }

  async function setGiftAccordingToThreshold(){
    const cart = await waitForCartSettle();
    if(!cart) return false;

    const eligible = eligibleSubtotalCents(cart) >= THRESHOLD_CENTS;
    const giftLine = findGiftLine(cart);
    const hasQty = giftLine ? giftLine.quantity : 0;
    const wantQty = eligible ? 1 : 0;

    if (hasQty === wantQty) return false;

    if (wantQty === 1){
      if (giftLine){
        if (giftLine.quantity !== 1) return await setLineQtyByKey(giftLine.key, 1);
        return false;
      } else {
        return await addGiftTagged();
      }
    } else {
      if (giftLine) return await setLineQtyByKey(giftLine.key, 0);
      return false;
    }
  }

  function detectSectionsOnPage(){
    return SECTION_IDS.filter(id => document.getElementById(`shopify-section-${id}`));
  }
  async function fetchSections(ids){
    if(!ids.length) return null;
    const url = `${location.pathname}?sections=${encodeURIComponent(ids.join(','))}`;
    const res = await fetch(url,{credentials:'same-origin'});
    return res.json();
  }
  async function refreshDrawerUI(){
    try{
      const ids = detectSectionsOnPage();
      if(!ids.length){
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('ajaxCart:updated'));
        window.dispatchEvent(new Event('cart:refresh'));
        document.dispatchEvent(new CustomEvent('thb:cart:refresh'));
        return;
      }
      const json = await fetchSections(ids);

      const drawer = document.querySelector('cart-drawer');
      if(drawer && typeof drawer.renderContents === 'function'){
        drawer.renderContents({ sections: json, cartItemKey: null });
      } else {
        ids.forEach(id => {
          const el = document.getElementById(`shopify-section-${id}`);
          if(el && json[id]) el.innerHTML = json[id];
        });
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('ajaxCart:updated'));
      window.dispatchEvent(new Event('cart:refresh'));
      document.dispatchEvent(new CustomEvent('thb:cart:refresh'));

      setTimeout(async ()=>{
        const json2 = await fetchSections(ids);
        const drawer2 = document.querySelector('cart-drawer');
        if(drawer2 && typeof drawer2.renderContents === 'function'){
          drawer2.renderContents({ sections: json2, cartItemKey: null });
        } else if(json2) {
          ids.forEach(id => {
            const el = document.getElementById(`shopify-section-${id}`);
            if(el && json2[id]) el.innerHTML = json2[id];
          });
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('ajaxCart:updated'));
        window.dispatchEvent(new Event('cart:refresh'));
        document.dispatchEvent(new CustomEvent('thb:cart:refresh'));
      }, SECOND_REPAINT_MS);
    } catch(e){}
  }

  let inFlight = false;
  async function runPipeline(){
    if(inFlight) return;
    inFlight = true;
    try{
      const changed = await setGiftAccordingToThreshold();
      if(changed) await refreshDrawerUI();
    } finally {
      inFlight = false;
    }
  }

  const origFetch = window.fetch;
  window.fetch = async function(){
    const res = await origFetch.apply(this, arguments);
    try{
      const url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0].url;
      if(url && /\/cart(\/add\.js|\/change\.js|\/update\.js|\.js|\?sections)/.test(url)){
        setTimeout(runPipeline, 80);
      }
    } catch(e){}
    return res;
  };

  const XHR = window.XMLHttpRequest;
  if(XHR){
    const send = XHR.prototype.send;
    XHR.prototype.send = function(){
      this.addEventListener('load', function(){
        try{
          if(this.responseURL && /\/cart(\/add\.js|\/change\.js|\/update\.js|\.js|\?sections)/.test(this.responseURL)){
            setTimeout(runPipeline, 80);
          }
        } catch(e){}
      });
      return send.apply(this, arguments);
    };
  }

  document.addEventListener('submit', e => {
    const f = e.target;
    if(f && /\/cart\/add/.test(f.action || '')) setTimeout(runPipeline, 200);
  }, true);
  document.addEventListener('click', e => {
    const b = e.target.closest('button, a');
    if(!b) return;
    const name = (b.getAttribute('name') || '').toLowerCase();
    const id = (b.id || '').toLowerCase();
    const cls = (b.className || '').toString().toLowerCase();
    if(name === 'add' || /add-to-cart|atc|ajax-add|product-form__submit/.test(id + ' ' + cls)){
      setTimeout(runPipeline, 200);
    }
  }, true);

  document.addEventListener('cart:open', runPipeline);
  document.addEventListener('thb:cart:open', runPipeline);
  document.addEventListener('DOMContentLoaded', runPipeline);
  setInterval(runPipeline, 2500);
})();

